import Action from "../base/action";
import LoadTimeline from "../base/load-timeline";
import {applyPruneToTimelineItem} from "../base/training-literals";

class ModelSelect extends Action {
    until;
    defaultAction;
    pickAction;
    _stopper;

    constructor(props) {
        super(props);
        this.until = props.until;
        this.defaultAction = props.defaultAction && new LoadTimeline(props.defaultAction);
        this.pickAction = Object.fromEntries(props.timelineMap.map(item => {
            const timelineItem = applyPruneToTimelineItem(item, props.prune);
            return [item.model.id, new LoadTimeline(timelineItem)];
        }));
        this._stopper = () => {
        };
    }

    async execute(eventLoop) {
        let self = this;
        this._stopper = activateModelSelect();
        setTimeout(this._stopper, self.until - self.startTime);

        function activateModelSelect() {
            VR.canvas.addEventListener('model_selected', handleModelSelected);
            return () => VR.canvas.removeEventListener('model_selected', handleModelSelected);
        }

        async function handleModelSelected(event) {
            const nextAction = getNextTimeline(event.detail.modelId);
            if (nextAction) {
                self._stopper();
                await nextAction.execute(eventLoop);
            }
        }

        function getNextTimeline(modelId) {
            const resources = eventLoop.training.resources;
            let trainingModelId;
            for (let trainingResourceId in resources) {
                if (resources[trainingResourceId].resourceId === modelId ||
                    (resources[trainingResourceId].type === ResourceTypeEnum.HELPER_OBJECT && resources[trainingResourceId].id === modelId)) {
                    trainingModelId = trainingResourceId;
                    break;
                }
            }

            if (self.pickAction[trainingModelId]) {
                return self.pickAction[trainingModelId];
            }

            if (self.defaultAction && (self.defaultAction.timelines.length || (self.defaultAction.events && self.defaultAction.events.length))) {
                return self.defaultAction;
            }

        }
    }

    async stop() {
        this._stopper();
    }
}

export default ModelSelect;
